import * as yup from 'yup';

export const instantExportSchema = yup.object().shape({
  filename: yup.string()
    .required('File Name is required')
    .matches(
      /^(?=[^\s])([\pA-Za-z0-9: .,\-/'"[\]{}!@#$%^&*()]+)(?<=[^\s])$/,
      'Export file name contains invalid characters. Please try again.'
    ),
})

export const savedReportSchema = yup.object().shape({
  name: yup.string()
    .required('Name is required')
    .matches(
      /^(?=[^\s])([\pA-Za-z0-9: .,\-/'"[\]{}!@#$%^&*()]+)(?<=[^\s])$/,
      'Report name contains invalid characters. Please try again.'
    ),
})

const distributionListSchema = yup.object().shape({
  id: yup.string().required(),
  name: yup.string().required(),
  recipients: yup.array()
    .of(
      yup.string()
        .email('Each group list recipient must be a valid email address')
        .required('Email is required')
    )
    .min(1, 'Group list must have at least one recipient')
    .required('Group list recipients are required'),
})

export const scheduledExportSchema = yup.object().shape({
  id: yup.string().nullable(),
  filename: yup.string()
    .required('File Name is required')
    .matches(
      /^(?=[^\s])([\pA-Za-z0-9: .,\-/'"[\]{}!@#$%^&*()]+)(?<=[^\s])$/,
      'Scheduled export file name contains invalid characters. Please try again.'
    ),
  frequency: yup.string()
    .oneOf(['daily', 'workdays', 'weekly', 'monthly'])
    .required('Frequency is required'),
  weekCount: yup.number()
    .nullable()
    .when('frequency', {
      is: 'weekly',
      then: (schema) => schema.required('# Weeks is required'),
      otherwise: (schema) => schema.notRequired(),
    }),
  dayOfWeek: yup.string()
    .nullable()
    .oneOf([null, 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'])
    .when('frequency', {
      is: 'weekly',
      then: (schema) => schema.required('Day is required'),
      otherwise: (schema) => schema.notRequired(),
    }),
  dayOfMonth: yup.number()
    .nullable()
    .when('frequency', {
      is: 'monthly',
      then: (schema) => schema.required('# Day is required'),
      otherwise: (schema) => schema.notRequired(),
    }),
  timeOfDay: yup.date()
    .required('Time is required'),
  recipients: yup.array()
    .of(
      yup.string()
        .email('Each recipient must be a valid email address')
        .required('Email is required')
    )
    .default([]),
  distributionLists: yup.array()
    .of(distributionListSchema)
    .default([]),
})
.test(
  'invalid-combination',
  'If frequency is daily or workdays, weekCount, dayOfWeek, and dayOfMonth should not be set',
  function (value) {
    const { frequency, weekCount, dayOfWeek, dayOfMonth } = value || {}
    if (frequency && ['daily', 'workdays'].includes(frequency)) {
      return !weekCount && !dayOfWeek && !dayOfMonth
    }
    return true
  }
)
.test(
  'at-least-one-recipient-source',
  'Recipient(s) are required',
  function (value) {
    const hasRecipients = (value?.recipients?.length || 0) > 0
    const hasDistributionLists = (value?.distributionLists || []).some(
      (list) => (list?.recipients?.length || 0) > 0
    )
    if (hasRecipients || hasDistributionLists) {
      return true
    }
    return this.createError({
      path: 'recipients',
      message: 'Recipient(s) are required',
    })
  }
)
